import { useEffect, useState } from 'react';

/**
 * Debounce a fast-changing value (e.g. a search box). The palette only fires a
 * query after the user pauses, so we don't hammer `/api/search` on every
 * keystroke (the search daily/quota discipline — replit.md §0.4). The value
 * updates immediately on the first pass and after each `delayMs` of quiet.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
